// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__-1cCm","range":"MonthRangeSwitch_range__17mCt","disabled":"MonthRangeSwitch_disabled__26rl2"};